module.exports = __webpack_public_path__ + "img/build.8347b9da.svg";